import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function Modal({ id, children }) {
  useEffect(() => {
    $(`#${id}`).modal({ backdrop: 'static' });

    return () => {
      $(`#${id}`).modal('hide');
    };
  }, [id]);

  return (
    <div className="modal fade" id={id} tabIndex="-1" role="dialog">
      {children}
    </div>
  );
}

Modal.propTypes = {
  /** modal container html id */
  id: PropTypes.string,
  /** React components to render inside the modal */
  children: PropTypes.node.isRequired,
};

Modal.defaultProps = {
  id: 'modalContainer',
};

export default Modal;
